import { createReducer, on } from '@ngrx/store';
import * as SalesUserActions from './sales-user.actions';
import { SalesUser } from '../../models/SalesUser';

export interface SalesUserState {
    salesUsers: SalesUser[] | null;
    currentSalesUser: SalesUser | null;
    error: any;
}

export const initialState: SalesUserState = {
    salesUsers: null,
    currentSalesUser: null,
    error: null
};

export const salesUserReducer = createReducer(
    initialState,
    // Load all sales users
    on(SalesUserActions.loadSalesUsersSuccess, (state, { salesUsers }) => ({
        ...state,
        salesUsers,
        error: null
    })),
    on(SalesUserActions.loadSalesUsersFailure, (state, { error }) => ({
        ...state,
        error
    })),

    // Get current sales user (me)
    on(SalesUserActions.loadSalesUserMeSuccess, (state, { salesUser }) => ({
        ...state,
        currentSalesUser: salesUser,
        error: null
    })),
    on(SalesUserActions.loadSalesUserMeFailure, (state, { error }) => ({
        ...state,
        error
    })),

    // Get sales user by Azure Object ID
    on(SalesUserActions.loadSalesUserSuccess, (state, { salesUser }) => ({
        ...state,
        currentSalesUser: salesUser,
        error: null
    })),
    on(SalesUserActions.loadSalesUserFailure, (state, { error }) => ({
        ...state,
        error
    })),

    // Change coins for a sales user
    on(SalesUserActions.changeSalesUserCoinsSuccess, (state, { salesUser }) => ({
        ...state,
        currentSalesUser: salesUser,
        salesUsers: state.salesUsers 
            ? state.salesUsers.map(su => su.id === salesUser.id ? salesUser : su)
            : null,
        error: null
    })),
    on(SalesUserActions.changeSalesUserCoinsFailure, (state, { error }) => ({
        ...state,
        error
    })),

    // Add coins to a customer by a sales user
    on(SalesUserActions.addCoinsToCustomerSuccess, (state, { salesUser }) => ({
        ...state,
        currentSalesUser: salesUser,
        salesUsers: state.salesUsers 
            ? state.salesUsers.map(su => su.id === salesUser.id ? salesUser : su)
            : null,
        error: null
    })),
    on(SalesUserActions.addCoinsToCustomerFailure, (state, { error }) => ({
        ...state,
        error
    }))
);
